import React from 'react';
import styles from './Table.module.scss';

const TableHead = (props) => <thead className={styles.tableHead}>{props.children}</thead>;

export default TableHead;
